module.exports = __webpack_public_path__ + "static/media/m13tj1023.9ba779ba.png";